import {CITY_COMMON_BUILDING_TOKENS, KEY_POINT_TOKENS} from "../../constants/tokens";

export const getAllCityHexKeys = (city) => {
  const allHexKeys = [city.centralQuarter];

  Object.keys(CITY_COMMON_BUILDING_TOKENS).forEach(key => {
    const value = CITY_COMMON_BUILDING_TOKENS[key];
    allHexKeys.push(...city[value]);
  });
  Object.keys(KEY_POINT_TOKENS).forEach(key => {
    const value = KEY_POINT_TOKENS[key];
    allHexKeys.push(...city[value]);
  });

  return allHexKeys;
}